import {
  getTrueFalseSingleChoiceValue,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';

export const option_with_disabled = (
  data: PLAYER_PORTALS_MODELS.OptionWithDisabled,
) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;
  return {
    label: elements?.name?.value,
    value: elements?.id?.value,
    isDisabled: getTrueFalseSingleChoiceValue(elements?.is_disabled),
    fontAwesomeIcon: elements?.font_awesome_icon?.value,
  };
};

export default option_with_disabled;
